import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastComponent } from '@hunting-nature/Secacam/shared/components/toast/toast.component';
import { ToastService } from '@hunting-nature/Secacam/shared/services/toast.service';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
  imports: [ToastComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  // services
  protected readonly toastService = inject(ToastService);
}
